import React, { createContext, useContext } from 'react';

const Context = createContext();

export const useImmutabilityChecks = () => useContext(Context);

export const ImmutabilityChecksProvider = ({ checks, children }) => {
  return <Context.Provider value={checks}>{children}</Context.Provider>;
};
